import droidSansUrl from './fonts/DroidSans.ttf';

export const PDF_UNICODE_FONT_FAMILY = 'DroidSans';
const PDF_UNICODE_FONT_FILE = 'DroidSans.ttf';

let fontDataPromise;

const arrayBufferToBase64 = buffer => {
  const bytes = new Uint8Array(buffer);
  const isTrueType = bytes.length >= 4
    && bytes[0] === 0x00
    && bytes[1] === 0x01
    && bytes[2] === 0x00
    && bytes[3] === 0x00;
  if (!isTrueType) {
    throw new Error('The PDF font response is not a valid TrueType font.');
  }
  const chunkSize = 0x8000;
  let binary = '';
  for (let offset = 0; offset < bytes.length; offset += chunkSize) {
    binary += String.fromCharCode(...bytes.subarray(offset, offset + chunkSize));
  }
  return window.btoa(binary);
};

const loadFontData = () => {
  if (!fontDataPromise) {
    fontDataPromise = fetch(droidSansUrl, { cache: 'no-store' }).then(response => {
      if (!response.ok) {
        throw new Error(`Could not load the PDF font (HTTP ${response.status}).`);
      }
      return response.arrayBuffer();
    }).then(arrayBufferToBase64).catch(error => {
      fontDataPromise = null;
      throw error;
    });
  }
  return fontDataPromise;
};

export const configureUnicodePdf = async doc => {
  const fontData = await loadFontData();
  doc.addFileToVFS(PDF_UNICODE_FONT_FILE, fontData);
  doc.addFont(PDF_UNICODE_FONT_FILE, PDF_UNICODE_FONT_FAMILY, 'normal');
  doc.setFont(PDF_UNICODE_FONT_FAMILY, 'normal');
  if (typeof doc.internal?.getFont === 'function') {
    const registeredFont = doc.internal.getFont(PDF_UNICODE_FONT_FAMILY, 'normal');
    if (!Array.isArray(registeredFont?.metadata?.Unicode?.widths)) {
      throw new Error('The PDF font could not be registered by jsPDF.');
    }
  }
  return PDF_UNICODE_FONT_FAMILY;
};
